export enum ReportPaymentCategories {
  INVOICE = 'INVOICE',
  EXPENSE = 'EXPENSE',
  PAYMENT = 'PAYMENT'
}
